import { computed, inject, Injectable, Signal } from '@angular/core';
import { OrderApiResponseStateService } from './order-api-response-state.service';
import { OrderOQResponse } from '../../../../../models/order/api-models/order-oq-response.model';

@Injectable({ providedIn: 'root' })
export class OrderQualificationResponseService {
    private orderApiResponseStateService = inject(OrderApiResponseStateService);
    orderOQResponse: Signal<OrderOQResponse> = this.orderApiResponseStateService.orderQualificationData;
    wirelessOQComponent = computed(() => {
        return this.orderOQResponse()?.Components?.Component?.find(comp => comp.ProductType === 'WIRELESS');
    });

    internetOQComponent = computed(() => {
        return this.orderOQResponse()?.Components?.Component?.find(comp => comp.ProductType === 'INTERNET');
    });

    oofOQComponent = computed(() => {
        return this.orderOQResponse()?.Components?.Component?.find(comp => comp.ProductType === 'OOF');
    });

    videoOQComponent = computed(() => {
        return this.orderOQResponse()?.Components?.Component?.find(comp => comp.ProductType === 'VIDEO');
    });

    oqComponents = computed(() => {
        return this.orderOQResponse()?.Components?.Component || [];
    });

    billingAccountNumber = computed(() => {
        return this.wirelessOQComponent()?.BillingAccountNumber || this.internetOQComponent()?.BillingAccountNumber || this.videoOQComponent()?.BillingAccountNumber || null;
    });

    rcc1Available = computed(() => {
        return !!this.oofOQComponent()?.RCC1;
    });

    rcc2Available = computed(() => {
        return !!this.oofOQComponent()?.RCC2;
    });

    creditCardRequired = computed(() => {
        return !!this.oofOQComponent()?.CreditCardRequired;
    });

    oofPaymentIFrameUrl = computed(() => {
        return this.oofOQComponent()?.Payment_iFrameUrl || '';
    });

    rccSmsAvailable = computed(() => {
        return !!this.oofOQComponent()?.RCCSMS;
    });

    rccEmailAvailable = computed(() => {
        return !!this.oofOQComponent()?.RCCEmail;
    });

    rccAgentAssistedFlowAvailable = computed(() => {
        return !!this.oofOQComponent()?.AgentAssistedFlow;
    });
}
